import React from 'react';
import styles from '../ManagePage.module.css';
import { formatScoreDate } from './SingleScoreCard';

// Bulk listing-score card for the Manage page — mirrors BulkProjectCard's stacked
// layout, with a product count, first/last ASIN pills, and a "Score" edge badge.
const BulkScoreCard = ({ batch, onClick }) => {
    const count = batch.results.length;
    const asins = batch.results.map((r) => r.asin).filter(Boolean);
    const previewImage = batch.results.find((r) => r.product_info?.main_image)?.product_info.main_image;

    return (
        <div className={`${styles.generationCardBulk} ${styles.stackedBulkCard}`} onClick={onClick}>
            <div className={styles.generationCardBulkLayer1}></div>
            <div className={styles.generationCardBulkLayer2}></div>
            <div className={styles.generationCardBulkMain}>
                <div className={styles.recentProjectInner}>
                    <div className={styles.cardImage}>
                        {previewImage ? (
                            <img
                                src={previewImage}
                                alt="Bulk score preview"
                                className={styles.recentProjectImageBulk}
                                loading="lazy"
                            />
                        ) : (
                            <div className={styles.imagePlaceholder}>No Image</div>
                        )}
                    </div>
                    <div className={styles.recentProjectDetails}>
                        <div className={styles.recentProjectDetailsTop}>
                            <div className={styles.cardTitle}>
                                {count} {count === 1 ? 'Product' : 'Products'}
                            </div>
                            <div className={styles.asinPillRow}>
                                {asins.length > 0 && (
                                    <div className={styles.recentProjectIdTag}>
                                        <span>{asins[0]}</span>
                                    </div>
                                )}
                                {asins.length > 1 && (
                                    <div className={styles.recentProjectIdTag}>
                                        <span>{asins[asins.length - 1]}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className={styles.cardDate}>
                            <span>{formatScoreDate(batch.completed_at)}</span>
                        </div>
                    </div>
                </div>
                <div className={styles.recentProjectScoreBadgeBulk}>
                    <span>Score</span>
                </div>
            </div>
        </div>
    );
};

export default BulkScoreCard;
